import React, { useState, Fragment } from 'react';
import {DispenseStatementFilterOption, DispenseStatementPageLabels, PillPackComFilterOption} from "../component";
import './DispenseStatement.scss';
import PillPackComMigrationBanner from "./PillPackComMigrationBanner";

interface DispenseStatementFilterOptionsProps {
    labels: DispenseStatementPageLabels;
    filterOptions: DispenseStatementFilterOption[];
    pillPackComFilterOptions?: PillPackComFilterOption[];
    pillPackComMigrationStatus?: string;
    onDownloadClick(filterOption:string | undefined): void;
    alertMessage?: string;
    hideFilterOption?: string;
    showChooseYear?: boolean;
}

function DispenseStatementFilterOptions(props: DispenseStatementFilterOptionsProps) {
    const [currentFilterValue, setCurrentFilterValue] = useState(null);

    const handleRadioClick = (e: React.MouseEvent<any>) => {
        e.preventDefault();
        setCurrentFilterValue(e.currentTarget.value);
    }

    const handleDownloadClick = () => {
        props.onDownloadClick(currentFilterValue || undefined);
    }

    const renderAlert = () => {
        return(
            <>
                <pui-box theme="error" style={{width: "auto", marginTop: "24px"}} >
                    <pui-stack direction="horizontal">
                        <pui-stack-item>
                            <pui-icon imgClass="status-error-icon" spacingRight="small"/>
                        </pui-stack-item>
                        <pui-stack-item overflow="true">
                            <pui-text input={props.alertMessage}/>
                        </pui-stack-item>
                    </pui-stack>
                </pui-box>
            </>
        );
    }

    const renderFilterOption = (
        filterOption: DispenseStatementFilterOption | PillPackComFilterOption,
        prefix: string,
        isLast: boolean) => {
        if (props.hideFilterOption && filterOption.value === props.hideFilterOption) return;
        const prefixedValue = `${prefix}-${filterOption.value}`;
        return(
            <Fragment key={prefixedValue}>
                <pui-radio-button
                    name="filterOption"
                    value={prefixedValue}
                    label={filterOption.label}
                    onClick={handleRadioClick}
                    checked={currentFilterValue === prefixedValue || undefined}
                />
                {!isLast && <pui-divider spacingBottom="small" spacingTop="small" />}
            </Fragment>
        );
    }

    const renderFilterOptions = () => {
        return props.filterOptions.map((option, index, array) => 
            renderFilterOption(option, 'pharmacy', index === array.length - 1)
        );
    }

    const renderPillPackComFilterOptions = () => {
        return props.pillPackComFilterOptions?.map((option, index, array) =>
            renderFilterOption(option, 'pillpack', index === array.length - 1)
        ) || [];
    }

    const pillPackComFilterOptionsBanner = (marginBottom: string) => {
        return <pui-text style={{marginBottom: marginBottom}}
                         input={props.labels.pillPackCom}
                         fontWeight="bold"/>;
    }

    return (
        <pui-section flowdirection="vertical" style={{gap: "24px"}}>
            <pui-section-column>
                {props.showChooseYear && <pui-text input={props.labels.chooseYear}/>}
                {props.alertMessage && renderAlert()}
            </pui-section-column>
                <pui-section-column class={"dispense-statement__filter-options-list"}>
                    <pui-text style={{marginBottom: "18px"}} input={props.labels.amazonPharmacy} fontWeight="bold"/>
                    {renderFilterOptions()}
                    {(() => {
                        switch(props.pillPackComMigrationStatus) {
                            case "IN_PROGRESS":
                                return (
                                    <div style={{marginTop: "16px"}}>
                                        {pillPackComFilterOptionsBanner("13px")}
                                        <PillPackComMigrationBanner
                                            pillPackComStatementsInProgress=
                                                {props.labels.pillPackComStatementsInProgress}
                                            pillPackComCheckBackLater={props.labels.pillPackComCheckBackLater}
                                        />
                                    </div>
                                );
                            case "COMPLETE":
                                return props.pillPackComFilterOptions && props.pillPackComFilterOptions.length > 0 && (
                                    <div style={{marginTop: "16px"}}>
                                        {pillPackComFilterOptionsBanner("18px")}
                                        {renderPillPackComFilterOptions()}
                                    </div>
                                );
                            default:
                                // If the migration status is NOT_FOUND or undefined, don't render any statement options
                                return null;
                        }
                    })()}
                </pui-section-column>
            <pui-section-column>
                <pui-button
                    id="button-to-download-dispense-statement"
                    data-csa-c-type="button"
                    data-csa-c-action="download"
                    data-csa-c-content-id="button-to-download-dispense-statement"
                    data-csa-c-slot-id="dispense-statement"
                    label={props.labels.download}
                    spacingTop="none"
                    textColor="black-color"
                    textSize="extra-large"
                    disabled={currentFilterValue === null || undefined}
                    onClick={handleDownloadClick}
                    icon="dispense-statement__download-icon"
                />
            </pui-section-column>
        </pui-section>
    );
}

export default DispenseStatementFilterOptions;